import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import ArticlePreview from './components/ArticlePreview';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://mulebuyspreadsheets.cyou';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <title>Mulebuy Spreadsheet – The Ultimate Comparison & Buying Intelligence Hub</title>
      <meta name="description" content="Discover the Mulebuy Spreadsheet system for smarter product comparison, price tracking, and sourcing intelligence. Structured guides, rankings, and comparison tools for international buyers." />
      <meta name="keywords" content="mulebuy spreadsheet, mulebuy spreadsheet guide, mulebuy spreadsheet comparison, product comparison, buying intelligence, sourcing tools" />
      <link rel="canonical" href={SITE_URL + '/'} />
      <meta property="og:title" content="Mulebuy Spreadsheet – The Ultimate Comparison & Buying Intelligence Hub" />
      <meta property="og:description" content="Discover the Mulebuy Spreadsheet system for smarter product comparison, price tracking, and sourcing intelligence." />
      <meta property="og:url" content={SITE_URL + '/'} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Mulebuy Spreadsheet – Comparison & Buying Intelligence Hub" />
      <meta name="twitter:description" content="Discover the Mulebuy Spreadsheet system for smarter product comparison and sourcing." />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Mulebuy Spreadsheet",
          "url": SITE_URL + '/',
          "description": "The ultimate comparison and buying intelligence hub for international buyers. Structured guides, rankings, and comparison tools for smarter shopping decisions.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": SITE_URL + "/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Mulebuy Spreadsheet – Comparison & Buying Intelligence Hub",
          "url": SITE_URL + '/',
          "description": "Discover the Mulebuy Spreadsheet system for smarter product comparison, price tracking, and sourcing intelligence. Structured guides, rankings, and comparison tools.",
          "inLanguage": "en",
          "dateModified": "2026-06-22",
          "about": {
            "@type": "Thing",
            "name": "Mulebuy Spreadsheet",
            "description": "A structured comparison system for evaluating products, agents, and sourcing options"
          }
        })
      }} />
      <Header />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <ArticlePreview />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}